import { safeGetCookie } from './cookie.mjs';

function getTrackingUuid() {
  const cookieMatch = safeGetCookie().match(/babbeltrackinguuid=([^;]+)/);
  const trackingUuid = cookieMatch?.[1];
  return trackingUuid;
}

export { getTrackingUuid };
